/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamClassGridItemViewModel } from "../types/ExamClassGridItemViewModel.ts";

export const examClassGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da turma.")),
  classRoomCode: z
    .string()
    .describe("Código identificador da turma. Opcional.")
    .nullish(),
  disciplinesId: z
    .number()
    .int()
    .describe("ID da disciplina associada à turma. Opcional.")
    .nullish(),
  disciplineCode: z
    .string()
    .describe("Código da disciplina associada à turma. Opcional.")
    .nullish(),
  disciplineText: z
    .string()
    .describe("Nome da disciplina associada à turma. Opcional.")
    .nullish(),
  dateStart: z.optional(
    z.string().datetime().describe("Data de início da turma."),
  ),
  dateFinish: z.optional(
    z.string().datetime().describe("Data de término da turma."),
  ),
  status: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status atual da turma. Valor numérico conforme tabela de status de turmas do sistema.",
      ),
  ),
  statusText: z
    .string()
    .describe("Descrição textual do status da turma. Opcional.")
    .nullish(),
  slides: z.optional(
    z.number().int().describe("Quantidade de slides disponíveis na turma."),
  ),
  hasExam: z.optional(
    z
      .number()
      .int()
      .describe("Indica se a turma possui prova associada (1 = sim, 0 = não)."),
  ),
  channels: z.optional(
    z
      .boolean()
      .describe("Indica se a turma possui canais de comunicação habilitados."),
  ),
  isModule: z.optional(
    z.boolean().describe("Indica se a turma pertence a um módulo."),
  ),
  moduleId: z
    .number()
    .int()
    .describe("ID do módulo ao qual a turma pertence. Opcional.")
    .nullish(),
  moduleName: z
    .string()
    .describe("Nome do módulo ao qual a turma pertence. Opcional.")
    .nullish(),
  typeRoom: z
    .number()
    .int()
    .describe(
      "Tipo de sala da turma. Opcional. Enum ETypeRoom: `1` = Virtual, `2` = Physical, `3` = Mixed.",
    )
    .nullish(),
  classStudents: z
    .array(z.string())
    .describe(
      "Lista de identificadores dos grupos de alunos (ClassStudent) vinculados à turma.",
    )
    .nullish(),
  firstClassName: z
    .string()
    .describe("Nome do primeiro grupo de alunos vinculado à turma. Opcional.")
    .nullish(),
  tryCount: z
    .number()
    .int()
    .describe(
      "Número máximo de tentativas permitidas para a prova associada à turma. Opcional.",
    )
    .nullish(),
  dateStartExam: z
    .string()
    .datetime()
    .describe(
      "Data de início do período de realização da prova na turma. Opcional.",
    )
    .nullish(),
  dateEndExam: z
    .string()
    .datetime()
    .describe(
      "Data de término do período de realização da prova na turma. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<ExamClassGridItemViewModel>;
